import { useState } from 'react';

import { ModalBase } from './ModalBase';

export interface ReopenAlertModalProps {
  open: boolean;
  alert: { id: string } | null;
  onClose: () => void;
  onConfirm: (p: { reason: string }) => void;
}

// Convertido verbatim de design-references/brief-3/shared/modals-3.jsx:409-432.
export function ReopenAlertModal({
  open,
  alert,
  onClose,
  onConfirm,
}: ReopenAlertModalProps): React.JSX.Element | null {
  const [reason, setReason] = useState('');
  if (!open || alert === null) return null;
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Reabrir alerta"
      width={500}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button type="button" className="btn-ghost-mini" onClick={onClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-ghost-mini btn-ghost-mini--primary"
            disabled={reason.trim().length < 10}
            onClick={() => onConfirm({ reason })}
          >
            Reabrir
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__callout modal-form__callout--warn">
          Alert volta para <b>Ativos</b> com flag <span className="mono">Reopened</span>. Audit log
          registra reabertura.
        </div>
        <label className="modal-form__field">
          <span className="modal-form__label">Motivo da reabertura</span>
          <textarea
            className="modal-form__textarea"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="Situação se repetiu / nova evidência / decisão revisada."
          />
        </label>
      </div>
    </ModalBase>
  );
}
